import { render, staticRenderFns } from "./productProcess.vue?vue&type=template&id=4b4281e9&scoped=true"
import script from "./productProcess.vue?vue&type=script&lang=js"
export * from "./productProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4281e9",
  null
  
)

export default component.exports